import React from 'react';
import PopupNg from '@/ui/PopupNg';
import { registerPopup } from '@/ui/popupRegistrar';
import { scrollBody } from '@/common/client';
import { DialogBody, Docked } from '@/ui/dialogs/Dialog';
import { set2FAContext } from 'nike-ui/src/components/2fa';
import Wizard2FA from 'nike-ui/src/components/2fa/views/Wizard2FA';
import DataChangeVerification from 'nike-ui/src/components/2fa/views/verification/DataChangeVerification';
import ClientParamChangeVerification from 'nike-ui/src/components/2fa/views/verification/ClientParamChangeVerification';
import { navigate } from '@/routing';
import { ACCOUNT_PROFILE } from '@/routing/routes';
import { dispatch } from 'nike-re-framejs';

export function start2FA(jwt, methods, reason, payload, onSuccess, onClose) {
    return db => [
        () => set2FAContext(jwt, methods, reason, payload, onSuccess),
        db.update(PopupNg.updater.open('2fa-wizard', { onClose })).deleteIn(['2FA'])
    ];
}

registerPopup('2fa-wizard', popup => <Auth2FAWizard {...popup.get('data')} />);

function Auth2FAWizard({ onClose }) {
    function close() {
        scrollBody(true);
        if (onClose) onClose();
    }
    return (
        <Docked onClose={close}>
            <DialogBody>
                <Wizard2FA onClose={() => dispatch(['ui.popup/ng-close'])} />
            </DialogBody>
        </Docked>
    );
}

registerPopup('data-change-verification', popup => <DataChangeVerificationDialog {...popup.get('data')} />);

function DataChangeVerificationDialog({ forcedActionsCrm }) {
    function onClose() {
        scrollBody(true);
    }

    function navigateToProfile() {
        navigate(ACCOUNT_PROFILE);
    }

    function close() {
        PopupNg.dispatcher.close();
        onClose();
    }

    return (
        <Docked onClose={onClose}>
            <DialogBody>
                <DataChangeVerification
                    forcedActionsCrm={forcedActionsCrm}
                    onAction={navigateToProfile}
                    onClose={close}
                />
            </DialogBody>
        </Docked>
    );
}

registerPopup('client-param-change-verification', popup => (
    <ClientParamChangeVerificationDialog {...popup.get('data')} />
));

function ClientParamChangeVerificationDialog({ forcedActionCrm }) {
    function onClose() {
        scrollBody(true);
    }

    function close() {
        PopupNg.dispatcher.close();
        onClose();
    }

    return (
        <Docked onClose={onClose}>
            <DialogBody>
                <ClientParamChangeVerification forcedActionCrm={forcedActionCrm} onClose={close} />
            </DialogBody>
        </Docked>
    );
}
